import { Component, OnInit, Input, OnChanges, SimpleChanges , ViewChild, EventEmitter, Output} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigDataService } from '../../../services/config-data.service';
import { DatosPersonales } from 'app/models/datos-personales';
import { PersonalService } from 'app/services/personal.service';
import { PrimeNGConfig } from 'primeng/api';
import { MyValidations } from '../../../utils/my-validations';
import { TranslateService } from '@ngx-translate/core';
import { DatosOrganizativosService } from '../../../services/datosOrganizativos.service';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';
import { MatDialog } from '@angular/material/dialog';
import { ErroresService } from '../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PersonalCurrentFilter } from '../../../models/personalCurrentFIlter';
import { MomentSetService } from '../../../core/services/moment-set.service';

declare var jQuery:any;

@Component({
  selector: 'app-datos-personales',
  templateUrl: './datos-personales.component.html',
  styleUrls: ['./datos-personales.component.css']
})
export class DatosPersonalesComponent implements OnInit, OnChanges {
  
  @Input() personalRelacion;
  @Input() legajo;
  @Input() personalId;
  @Input() idfiscal;
  @Input() fechaNacimiento;
  @Input() idioma;
  @Input() nacionalidad;
  @Input() showDatosPersonales;
  @Output() CargarHijo11 = new EventEmitter<''>();
  
  @ViewChild('fecNacimiento') fecNacimiento: any;

  disabledEditing:boolean=true;

  edadMayoria: number = 18;
  tratamientosList: any;
  idiomasList: any;
  sexosList: any;
  paisesList: any;
  estadoCivilList: any;
  datosInvalida: boolean = false;
  MensajeError: string;

  isEditing: boolean = false;
  isHistory: boolean = false;
  permisoEdicion: boolean = false;

  datosPersonalesForm: FormGroup;  
  areEditing = false;

  public cargaCompleta: boolean = false;

  constructor(private configDataSrv: ConfigDataService,
              private personalSrv: PersonalService,
              private config: PrimeNGConfig,
              private translate: TranslateService,
              private formBuilder: FormBuilder,
              private dialog: MatDialog,
              private snackBar: MatSnackBar,
              private datosOrganizativosSrv: DatosOrganizativosService,
              private erroresService: ErroresService,
              private momentService: MomentSetService) { }

  get f() { return this.datosPersonalesForm.controls; }

  ngOnInit(): void {
    
    this.buildFrom();
    //no anda la traduccion por i18n por un bug, cuando se corrija lo cambiamos, por ahora hay que usar el ngOnInit
    this.translate.get('primeng').subscribe(res => {this.config.setTranslation(res);this.fechaNacimiento.ngOnInit;});
    this.setFormState(true);

    let filter: PersonalCurrentFilter={
      id: this.personalId,
      fecha: new Date().toDateString()
    };
    //Datos Organizativos vigente
    this.datosOrganizativosSrv.getByPersonalCurrent(filter).subscribe(
      data => 
      {
        this.edadMayoria = data.data.sociedadNavigation.mayoriaEdad;
      });
    
      
    this.configDataSrv.getDatosPersonales().subscribe(
      data => {
        this.tratamientosList=data["Tratamientos"];
        this.idiomasList=data["Idiomas"];
        this.sexosList=data["Sexos"];
        this.estadoCivilList=data["EstadoCivil"];
        this.paisesList=data["Paises"];

        this.cargaCompleta = true;
        this.CargarHijo11.emit();
      },
      error => {
        this.cargaCompleta = true;
        console.log(error);
      }
    );
    
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Datos Personales")) this.permisoEdicion = true;
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  buildFrom(){
    this.datosPersonalesForm = this.formBuilder.group({
      id: [this.personalRelacion.id, Validators.required],
      legajo: [this.personalRelacion.legajo],
      IDfiscal: [this.personalRelacion.idfiscal, Validators.required],
      fecNacimiento: [new Date(this.personalRelacion.fechaNacimiento),[Validators.required, MyValidations.isYounger(this.edadMayoria)]],
      nombre: [this.personalRelacion.nombre, [Validators.required, Validators.pattern(/^[\p{L}\s]+$/u)]],
      apellido: [this.personalRelacion.apellido, [Validators.required, Validators.pattern(/^[\p{L}\s]+$/u)]],
      segundoApellido: [this.personalRelacion.segundoApellido, Validators.pattern(/^[\p{L}\s]+$/u)],
      nacionalidad: [this.personalRelacion.nacionalidad, Validators.required],
      idioma: [this.personalRelacion.idioma, Validators.required],
      estadoCivil: [this.personalRelacion.estadoCivil, Validators.required],
      tratamiento: [this.personalRelacion.tratamiento, Validators.required],
      sexo: [this.personalRelacion.sexo, Validators.required],
      email: [this.personalRelacion.email, [Validators.required, Validators.email]],
      celular: [this.personalRelacion.celular,  [Validators.required, Validators.pattern(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/)]]    
    });    
  }

  setFormState(state: boolean){
    if(!state){
      this.datosPersonalesForm.controls['id'].enable();
      this.datosPersonalesForm.controls['legajo'].enable();
      this.datosPersonalesForm.controls['IDfiscal'].enable();
      this.datosPersonalesForm.controls['fecNacimiento'].enable();
      this.datosPersonalesForm.controls['nombre'].enable();
      this.datosPersonalesForm.controls['apellido'].enable();
      this.datosPersonalesForm.controls['segundoApellido'].enable();
      this.datosPersonalesForm.controls['nacionalidad'].enable();
      this.datosPersonalesForm.controls['idioma'].enable();
      this.datosPersonalesForm.controls['estadoCivil'].enable();
      this.datosPersonalesForm.controls['tratamiento'].enable();
      this.datosPersonalesForm.controls['sexo'].enable();
      this.datosPersonalesForm.controls['email'].enable();
      this.datosPersonalesForm.controls['celular'].enable();

    }else{
      this.datosPersonalesForm.controls['id'].disable();
      this.datosPersonalesForm.controls['legajo'].disable();
      this.datosPersonalesForm.controls['IDfiscal'].disable();
      this.datosPersonalesForm.controls['fecNacimiento'].disable();
      this.datosPersonalesForm.controls['nombre'].disable();
      this.datosPersonalesForm.controls['apellido'].disable();
      this.datosPersonalesForm.controls['segundoApellido'].disable();
      this.datosPersonalesForm.controls['nacionalidad'].disable();
      this.datosPersonalesForm.controls['idioma'].disable();
      this.datosPersonalesForm.controls['estadoCivil'].disable();
      this.datosPersonalesForm.controls['tratamiento'].disable();
      this.datosPersonalesForm.controls['sexo'].disable();
      this.datosPersonalesForm.controls['email'].disable();
      this.datosPersonalesForm.controls['celular'].disable();
    }
  }

  CancelChange(e: boolean){
    this.deshabilitarEdicion();
    this.buildFrom();
  }
  
  EditChange(e: boolean){
    this.habilitarEdicion();
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.setFormState(this.disabledEditing);
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.setFormState(this.disabledEditing);
  }

  SaveChange(e: boolean)
  {
    let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
      width: '400px'
    });
    dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

    let datosPer: DatosPersonales = {
      id: this.datosPersonalesForm.value.id,
      legajo: this.datosPersonalesForm.value.legajo,
      IDfiscal: this.datosPersonalesForm.value.IDfiscal,
      fecNacimiento: this.momentService.saveDateServer(this.datosPersonalesForm.value.fecNacimiento, false),
      nombre: this.datosPersonalesForm.value.nombre,
      apellido: this.datosPersonalesForm.value.apellido,
      segundoApellido: this.datosPersonalesForm.value.segundoApellido,
      nacionalidad: this.datosPersonalesForm.value.nacionalidad,
      estadoCivil: this.datosPersonalesForm.value.estadoCivil,
      idioma: this.datosPersonalesForm.value.idioma,
      tratamiento:this.datosPersonalesForm.value.tratamiento,
      sexo: this.datosPersonalesForm.value.sexo,
      email: this.datosPersonalesForm.value.email,
      celular: this.datosPersonalesForm.value.celular
    };

    this.personalSrv.SaveDatosPersonales(datosPer).subscribe(
      data =>
      {
        setTimeout(function ()
        {
          dialogProcesandoRef.close();
        });

        this.snackBar.open("Datos Personal guardado", "OK", { duration: 10000 });

        this.deshabilitarEdicion();
      },
      error => {
        dialogProcesandoRef.close();
        if (error.status == 400)
        {
          this.datosInvalida = true;
          
          this.MensajeError = this.erroresService.MostrarError400(error);
        }
        else
        {
          this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
        }
        
      });
  }
}
